import React, { useState, useEffect, useContext } from "react";
import { Dialog, Button, ButtonType, Checkbox, Spin } from "@yy/tofu-ui-react";
import { closeModal } from "./ModalSwitch";
import qs from "qs";
import { Toast } from "@yy/tofu-ui-react";
import { UserRoleContext } from "../../App";
import { useHistory, useLocation } from "react-router-dom";
import fetchers from "../../models/fetchers";
import './index.scss'
import { UserRole } from "../../lib/util";

const GuildServiceAgreement = () => {
  const history = useHistory();
  const [agree, setAgree] = useState(true)  // 是否同意签署协议
  const [content, setContent] = useState('')  // 公会协议内容
  const [version, setVersion] = useState(0)  // 公会协议版本号
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const userRole = useContext(UserRoleContext);
  const { beGuildRoute } = qs.parse(location.search, { ignoreQueryPrefix: true })

  // 获得最新的协议内容
  const getAgreementContent = async () => {
    setLoading(true)
    const rs = await fetchers['GET/protocol/detail']()
    if (rs.code === 0) {
      const { data } = rs
      setContent(data?.content as string)
      setVersion(data?.version as number)
      setLoading(false)
    } else {
      // 获取失败，关闭弹窗
      Toast.info({ text: rs.msg || '接口异常，请稍后再试' });
      closeModal(history);
    }
  }
  //  处理协议签署
  const handleSign = async () => {
    setLoading(true)
    let scene = 2
    if (userRole === UserRole.NormalUser) {
      scene = 1
    }
    const rs = await fetchers['POST/protocol/sign']({
      version,
      source: 0,  // 来源 0-web 1-h5
      scene: scene // 场景 0-存量签约 1-成为普通公会 2-升级星级公会
    })
    setLoading(false)
    if (rs.code === 0) {
      history.push(beGuildRoute as string);
    } else {
      Toast.info({ text: rs.msg || '接口异常，请稍后再试' });
    }
  }

  useEffect(() => {
    getAgreementContent()
  }, [])

  return (
    <Dialog
      active
      title="申请成为公会"
      showConfirmBtn={false}
      showCancelBtn={false}
      wrapperStyle={{ width: 600 }}
      onCancel={closeModal(history)}
    >
      <Spin spinning={loading}>
        <div className="guild_service_agreement">
          <div className="agreement_content" dangerouslySetInnerHTML={{ __html: content }}></div>
          <div className="opt">
            <p><Checkbox checked={agree} onChange={(flag) => setAgree(flag)}>已阅读并同意签署以上协议</Checkbox></p>
            <br />
            <Button
              type={ButtonType.Emphasis}
              disabled={!agree}
              onClick={handleSign}
            >
              确定绑定
            </Button>
          </div>
        </div>
      </Spin>
    </Dialog>
  );
};

export default GuildServiceAgreement;
